<template>
  <div class="accept-initiative">
    <div class="header">
      <p>Tashabbusni tasdiqlash</p>
    </div>
    <div class="form" v-loading="loading">
      <el-row>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
          <el-form
              ref="acceptForm"
              :model="acceptForm"
              :rules="rules"
              label-position="top"
              style="width: 100%"
              status-icon
              hide-required-asterisk
          >
            <el-form-item label="Kommentariya" prop="moderator_comment">
              <el-input v-model="acceptForm.moderator_comment" type="textarea"/>
            </el-form-item>

            <!--        //should be removed 3 line below-->
            <!--            <el-form-item label="Tashabbus tavsifi" prop="description"-->
            <!--                          v-if="!(productCount?.product_categories_count!==0&& acceptForm.type==='EQUIPMENT')">-->
            <!--              <el-input v-model="acceptForm.description" type="textarea"/>-->
            <!--            </el-form-item>-->

            <el-form-item label="Tashabbus kategoriyasi" prop="category_id">
              <el-select
                  v-model="acceptForm.category_id"
                  @change="changeCategory"
                  style="width: 100%"
                  :disabled="boardType==='MY_GARDEN'"
              >
                <el-option
                    v-for="category in categories"
                    :key="category.id"
                    :value="category.id"
                    :label="category.title"
                />
              </el-select>
            </el-form-item>
            <el-form-item
                label="Tashkilot nomi"
                prop="organization_id"
                v-if="showOrganizationField"
            >
              <el-select
                  v-model="acceptForm.organization_id"
                  style="width: 100%"
                  @change="changeOrganization"
              >
                <el-option
                    v-for="item in organizationList"
                    :key="item.id"
                    :value="item.id"
                    :label="item.title"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="Mahalla" prop="quarter_id">
              <el-select v-model="acceptForm.quarter_id" style="width: 100%" :disabled="showOrganizationField">
                <el-option
                    v-for="quarter in quarters"
                    :key="quarter.id"
                    :value="quarter.id"
                    :label="quarter.title"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="Loyiha turi" prop="type">
              <el-select v-model="acceptForm.type" style="width: 100%" disabled>
                <el-option
                    v-for="typeq in types"
                    :key="typeq.id"
                    :value="typeq.id"
                    :label="typeq.title"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="boardType!=='MY_GARDEN'" label="Buyurtmachini tanlang" prop="customer_id">
              <el-select
                  v-model="acceptForm.customer_id"
                  style="width:100%"
                  placeholder="Tanlang"
                  :remote-method="onCustomerSearch"
                  :loading="customersLoading"
                  filterable
                  remote
                  remote-show-suffix
              >
                <el-option
                    v-for="customer in customers"
                    :key="customer.id"
                    :value="customer.id"
                    :label="customer.tin + ' - ' + customer.title"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="acceptForm.category_id===11" label="Yo'l turini tanlang" prop="road_type">
              <el-select
                  v-model="acceptForm.road_type"
                  style="width:100%"
                  @change="onChangeRoadType"
                  placeholder="Tanlang"
              >
                <el-option
                    v-for="type in road_types"
                    :key="type.value"
                    :value="type.value"
                    :label="type.label"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="acceptForm.category_id===11" label="Yo'l uzunligini kiriting (m)" prop="road_length">
              <i style="color: #0271a0; margin-top: -10px">1 km uzunligi {{ oneRoadPrice?.toLocaleString('ru-RU') }} UZS</i>
              <el-input v-model="acceptForm.road_length" type="number" @input="handleRoadLength"
                        style="width: 100%"/>
            </el-form-item>
            <el-form-item label="So'ralgan mablag" prop="requested_amount">
              <el-input
                  disabled
                  v-model="acceptForm.requested_amount"
              ></el-input>
            </el-form-item>
            <el-form-item label="Maqullangan mablag'" prop="granted_amount">
              <el-input
                  :disabled="disableGrantedAmount"
                  v-model="acceptForm.granted_amount"
                  @input="handleGrantedAmount"
                  :formatter="formatterPrice"
              ></el-input>
            </el-form-item>
            <el-form-item v-if="boardType==='MY_GARDEN'" label="Izoh" prop="description">
              <el-input type="textarea" v-model="acceptForm.description"/>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="Yashil energiya" prop="is_energy_effective">
                  <el-checkbox v-model="acceptForm.is_energy_effective">
                    {{ acceptForm.is_energy_effective ? 'Ha' : "Yo'q" }}
                  </el-checkbox>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="Sheriklik loyihasi" prop="is_partnership">
                  <el-checkbox v-model="acceptForm.is_partnership" :disabled="!!acceptForm.organization_id">
                    {{ acceptForm.is_partnership ? 'Ha' : "Yo'q" }}
                  </el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>

            <!--        <el-form-item label="Teglar" prop="tags">-->
            <!--          <el-select-->
            <!--              clearable-->
            <!--              multiple-->
            <!--              collapse-tags-->
            <!--              collapse-tags-tooltip-->
            <!--              :max-collapse-tags="3"-->
            <!--              style="width: 100%"-->
            <!--              value-key="id"-->
            <!--              v-model="acceptForm.tags"-->
            <!--          >-->
            <!--            <el-option-->
            <!--                v-for="item in tags"-->
            <!--                :key="item.type"-->
            <!--                :value="item"-->
            <!--                :label="item.title"-->
            <!--            />-->
            <!--          </el-select>-->
            <!--        </el-form-item>-->
            <el-form-item>
              <span class="dialog-footer">
                <el-button @click="onClickBack">Orqaga</el-button>
                <reestr-edit-form :initiative="acceptForm.id"
                                  :initiative-detail="initiativeDetail"
                                  :initiative-category-id="acceptForm.category_id"
                                  v-if="productCount?.product_categories_count!==0 && acceptForm.type==='EQUIPMENT'"
                                  @getInitiative="getInitiativeById"/>
    <!--                        <reestr-edit-form :initiative="acceptForm.id"-->
    <!--                                          :initiative-category-id="acceptForm.category_id"-->
    <!--                                          @getInitiative="getInitiativeById"/>-->
                <el-button type="primary" @click="completeAccept">
                  Saqlash
                </el-button>
              </span>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {ElNotification} from "element-plus";
import ReestrEditForm from "@/components/reestr/ReestrEditForm.vue";
import {formatterPrice, integerPart, parserPrice} from "@/utils/common";
import debounce from 'lodash/debounce'

export default {
  name: "InitiativeList",
  components: {ReestrEditForm},
  data() {
    const self = this

    function amountValidate(rule, value, callback) {
      if (value === "0") {
        callback(new Error("Qiymat 0 dan katta bo'lishi kerak"));
      } else if (value && parserPrice(value) > self.getMaxAmountByType()) {
        callback(new Error(`Qiymat ${formatterPrice(self.max_amount)} dan kichick bo'lishi kerak`));
      } else {
        callback();
      }
    }

    return {
      loading: false,
      customersLoading: false,
      acceptForm: {
        id: null,
        granted_amount: null,
        moderator_comment: null,
        category_id: null,
        quarter_id: null,
        organization_id: null,
        type: null,
        tags: [],
        district_id: null,
        customer_id: null,
        road_type: null,
        road_length: null,
        board_id: null,
        is_energy_effective: false,
        is_partnership: false
      },
      initiativeDetail: null,
      max_amount: 0,
      boardType: null,
      tags: [],
      showOrganizationField: false,
      organizationList: [],
      quarters: [],
      categories: [],
      money: {
        decimal: ".",
        thousands: " ",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false
      },
      types: [
        {id: "CONSTRUCTION", title: "Qurilish"},
        {id: "EQUIPMENT", title: "Xarid qilish"},
      ],
      customers: [],
      road_types: [
        {value: "HALF_READY", label: "Shag'al yo'lni asfaltlash"},
        {value: "NOT_READY", label: "Tuproq yo'lni asfaltlash"}
      ],
      roadPrices: null,
      oneRoadPrice: null,

      rules: {
        customer_id: [
          {required: true, message: "Majburiy maydon", trigger: "change"},
        ],
        moderator_comment: [
          {required: false, message: "Majburiy maydon", trigger: "blur"},
        ],
        description: [
          {required: true, message: "Majburiy maydon", trigger: "blur"},
        ],
        file_id: [
          {required: true, message: "Majburiy maydon", trigger: "change"},
        ],
        granted_amount: [{validator: amountValidate, trigger: "blur"}],
        tags: [
          {required: true, message: "Majburiy maydon", trigger: "change"},
        ],
        organization_id: [
          {
            required: true,
            message: "Majburiy maydon",
            trigger: "change",
          },
        ],
        is_partnership: [
          {
            required: true,
            message: "Majburiy maydon",
            trigger: "change",
          },
        ],
      }
    }
  },
  computed: {
    productCount() {
      return this.categories.find(category => category.id === this.acceptForm.category_id)
    },
    disableGrantedAmount() {
      const selectedCategory = this.categories.find(item => item.id === this.acceptForm.category_id)
      return (selectedCategory?.product_categories_count > 0 && this.acceptForm.type === "EQUIPMENT") || selectedCategory?.id === 11
    }
  },
  watch: {
    'acceptForm.organization_id'(newVal) {
      if (newVal) {
        this.acceptForm.is_partnership = false
      }
    }
  },
  methods: {
    formatterPrice,
    handleRoadLength() {
      this.validateRoadLength()
    },
    validateRoadLength() {
      if (this.acceptForm.road_length * this.oneRoadPrice / 1000 > this.getMaxAmountByType()) {
        this.acceptForm.road_length = integerPart((this.getMaxAmountByType() / this.oneRoadPrice) * 1000)
        this.acceptForm.granted_amount = formatterPrice(this.acceptForm.road_length * this.oneRoadPrice / 1000)
      } else if (this.roadPrices) this.onChangeRoadType()
    },
    onChangeRoadType() {
      if (this.acceptForm.road_type === 'NOT_READY') {
        this.oneRoadPrice = this.roadPrices.price;
        this.acceptForm.granted_amount = formatterPrice(integerPart(this.acceptForm.road_length * this.roadPrices.price / 1000))
      } else {
        this.oneRoadPrice = this.roadPrices.half_ready_price
        this.acceptForm.granted_amount = formatterPrice(integerPart(this.acceptForm.road_length * this.roadPrices.half_ready_price / 1000))
      }

      this.$nextTick(() => {
        if (parserPrice(this.acceptForm.granted_amount) > this.getMaxAmountByType()) {
          this.validateRoadLength()
        }
      })
    },
    getMaxAmountByType () {
      switch (this.initiativeDetail.type) {
        case "EQUIPMENT":
          this.max_amount = this.initiativeDetail.board.equipment_initiatives_max_amount
          return this.initiativeDetail.board.equipment_initiatives_max_amount
        case "CONSTRUCTION":
          this.max_amount = this.initiativeDetail.board.initiatives_max_amount
          return this.initiativeDetail.board.initiatives_max_amount
      }
    },
    handleGrantedAmount(value) {
      const val = parseFloat(value.replace(/\s/g, ""))

      if (val && val > this.getMaxAmountByType()) {
        this.acceptForm.granted_amount = formatterPrice(this.getMaxAmountByType())
      }
    },

    onCustomerSearch: debounce(function (search) {
      this.getCustomers(search)
    }, 500),
    getCustomers(search, id = null) {
      if (!id && (!search || search.length < 3)) return

      this.customersLoading = true

      this.$http
          .get('api/v1/customers', {
            params: {
              limit: 100000,
              offset: 0,
              search,
              id
            },
          })
          .then(({ data }) => {
            this.customers = data.data
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response?.data?.message ||
                  "Xatolik yuz berdi, iltimos qayta urinib ko‘ring!",
            })
          })
          .finally(() => {
            this.customersLoading = false
          })
    },
    getRoadPrices() {
      this.loading = true;
      this.$http
          .get(`api/v1/road-prices`, {
            params: {
              board_id: this.acceptForm.board_id,
              district_id: this.acceptForm.district_id,
              limit: 10000,
              offset: 0
            },
          })
          .then(({data}) => {
            this.roadPrices = data.data[0];
            if (!this.acceptForm.road_type) {
              this.acceptForm.road_type = 'HALF_READY'
              this.oneRoadPrice = this.roadPrices.half_ready_price;
            } else {
              if (this.acceptForm.road_type === 'HALF_READY') {
                this.oneRoadPrice = this.roadPrices.half_ready_price;
              } else {
                this.oneRoadPrice = this.roadPrices.price
              }
            }

            this.$nextTick(() => {
              if (this.acceptForm.road_length) this.onChangeRoadType()
            })

          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response?.data?.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onClickBack() {
      this.$router.go(-1)
    },
    completeAccept() {
      if (!this.acceptForm.organization_id && !this.acceptForm.is_partnership) {
        this.recessQuartersCheck()
        return
      }
      this.sendAccept()
    },
    sendAccept() {
      this.$refs.acceptForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const formData = {
            ...this.acceptForm,
            granted_amount: parseFloat(parserPrice(this.acceptForm.granted_amount)),
            road_length: parseInt(this.acceptForm.road_length)
            // tags: this.acceptForm.tags.map((item) => item.id),
          };

          let url;
          if (this.$store.state.role === 'my_garden_moderator') {
            url = `api/v1/my-garden-moderators/accept/initiatives/${this.acceptForm.id}`
          } else {
            url = `api/v1/moderators/accept/initiatives/${this.acceptForm.id}`
          }
          this.$http
              .post(
                  url,
                  formData
              )
              .then(() => {
                ElNotification.success({
                  message: "Ma'qullash bajarildi.",
                });
                this.$router.go(-1);
              })
              .catch((error) => {
                ElNotification.error({
                  message:
                      error.response.data.message ||
                      "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      });
    },
    // getTags() {
    //   this.$http
    //       .get("api/v1/tags")
    //       .then(({data}) => {
    //         this.tags = data
    //       })
    //       .catch((err) => {
    //         console.error("tag fetch error", err);
    //       });
    // },
    getInitiativeById() {
      this.loading = true;
      this.$http
          .get(`api/v1/initiatives/${this.acceptForm.id}`)
          .then(({data}) => {
            this.initiativeDetail = data
            this.acceptForm.requested_amount = formatterPrice(data['requested_amount']);
            this.acceptForm.granted_amount = formatterPrice(data['granted_amount']);
            this.acceptForm.moderator_comment = data['moderator_comment'];
            this.acceptForm.category_id = data['category_id'];
            this.acceptForm.quarter_id = data['quarter_id'];
            this.acceptForm.organization_id = data['organization_id'];
            this.acceptForm.type = data['type'];
            this.acceptForm.tags = data['tags'];
            this.acceptForm.products = data['products'];
            this.acceptForm.district_id = data['district_id'];
            this.acceptForm.road_length = data['road_length'];
            this.acceptForm.board_id = data['board_id'];
            this.acceptForm.road_type = data['road_type'];
            this.acceptForm.customer_id = data['customer_id'];
            this.acceptForm.description = data['description'];
            this.acceptForm.is_partnership = data['is_partnership'];
            this.boardType = data?.board['type'];

            this.quarters.push({id: data['quarter_id'], title: data['quarter_title']})

            if (this.acceptForm.category_id === 11) {
              this.getRoadPrices();
            }

            if (this.acceptForm.organization_id) {
              this.getOrganizations(this.acceptForm.district_id, this.acceptForm.category_id);
            }
            this.getQuarters(this.acceptForm.district_id);
            this.getCustomers('', this.acceptForm.customer_id)
            // this.getTags();
          })
          .catch((err) => {
            console.error("quarters fetch error", err);
          })
          .finally(() => {
            this.loading = false
          });
    },

    changeCategory(e) {
      this.getOrganizations(this.acceptForm.district_id, e);
      if (this.acceptForm.category_id === 11) {
        this.getRoadPrices();
      }
    },

    getQuarters(districtId) {
      this.$http
          .get(`api/v1/quarters?district_id=${districtId}`)
          .then(({data}) => {
            this.quarters = [...this.quarters, ...data.quarters];
          })
          .catch((err) => {
            console.error("quarters fetch error", err);
          });
    },

    recessQuartersCheck() {
      this.loading = true;
      this.$http
          .get(`api/v1/state-budget/recess-quarters/check?board_id=${this.acceptForm.board_id}&quarter_id=${this.acceptForm.quarter_id}`)
          .then(({ data }) => {
            if (!data.exists) {
              this.sendAccept()
            }
          })
          .catch((err) => {
            if (err.response.data.code === "451") {
              ElNotification({
                type: 'error',
                title: 'Xatolik',
                message: err.response.data.message,
                duration: 6000,
              })
              return
            }
            ElNotification({
              type: 'error',
              title: 'Xatolik',
              message: 'Iltimos, qayta urinib ko\'ring',
            })
          })
          .finally(() => {
            this.loading = false
          });
    },

    getOrganizations(district_id, category_id) {
      const selectedOption = this.categories.find(
          (option) => option.id === category_id
      );
      this.showOrganizationField = !!selectedOption.organization_type;

      if (!this.showOrganizationField) {
        this.acceptForm.organization_id = null;
      }

      if (this.showOrganizationField) {
        this.loading = true;
        this.$http
            .get(
                `api/v1/organizations?district_id=${district_id}&&organization_type=${selectedOption.organization_type}`
            )
            .then((res) => {
              this.organizationList = res.data?.organizations;
            })
            .catch((error) => {
              console.log(error);
              ElNotification.error({
                message:
                    error.response.data.message ||
                    "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
              });
            })
            .finally(() => {
              this.loading = false;
            });
      }
    },

    changeOrganization (orgId) {
      const selectedOrg = this.organizationList.find(
          item => item.id === orgId
      )
      this.acceptForm.quarter_id = selectedOrg.quarter_id
    },

    getCategories() {
      this.$http
          .get(`api/v1/initiative-categories`, {
            params: {
              board_id: this.$route.params.boardId
            }
          })
          .then(({data}) => {
            this.categories = data.initiative_categories;
          })
          .catch((err) => {
            console.error("category fetch error", err);
          });
    },
  },
  mounted() {
    this.getCategories();
    if (this.$route.params.id) {
      this.acceptForm.id = this.$route.params.id;
      this.getInitiativeById()
    }
  }
}
</script>
<style scoped>

</style>
